<template>
  <v-card
    :height="$printTag.size(tagSettings.height)"
    :width="$printTag.size(tagSettings.width)"
    class="container--fluid card tag"
    outlined
  >
    <div style="word-break: break-word" class="pa-2 texto content">
      <b>{{ product.code }} - {{ product.name }}</b>
      <div class="d-flex justify-space-between align-center">
        <template v-if="tagSettings.showPrice">
          <div class="d-flex flex-column price">
            <span>
              À Vista R$
              {{ $format.decimal(product.product_variants[0].price_cash) }}
            </span>
            <small>
              À Prazo R$
              {{ $format.decimal(product.product_variants[0].price_forward) }}
            </small>
          </div>
        </template>
        <div
          v-if="qrCodeUrl"
          class="qr-code"
          :class="!tagSettings.showPrice && 'qr-code-w-100'"
        >
          <img :src="qrCodeUrl" alt="QR Code" />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    tagSettings: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ratio() {
      return this.tagSettings.width / this.tagSettings.height;
    },

    qrCodeUrl() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${this.product.code}`;
    },
  },
};
</script>

<style scoped>
.texto {
  font-size: 12px;
  letter-spacing: 1px;
}
.tag {
  margin-top: 3px;
  border: 1px dashed #66666688 !important;
}
.content {
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.price {
  gap: 2px;
}

.qr-code-w-100 {
  width: 100%;
}

.qr-code img {
  max-width: 50px;
  display: flex;
  align-items: center;
  place-self: end;
}
</style>
